import { TutorialJourneyType } from "@growth-machine-llc/stridist-api-client";
import { JOURNEY_ROUTE_CONFIG } from "../../constants";
import { matchPath } from "react-router-dom";
import { COACH_PROGRAMS_PUBLISHED_ROUTE } from "../routes";

/**
 * Determine which tutorial journey to run based on current URL.
 * We have to look at both the path *and* the "component" query param,
 * because the component editor route reuses the same "/curriculum" path.
 */
export const getJourneyTypeForPath = (
  pathname: string,
  search: string = "",
): TutorialJourneyType | null => {
  const params = new URLSearchParams(search);

  if (
    matchPath({ path: COACH_PROGRAMS_PUBLISHED_ROUTE, end: false }, pathname) &&
    params.get("subscription-status") === "succeeded"
  ) {
    return TutorialJourneyType.ONBOARDING;
  }

  if (params.has("component")) {
    return TutorialJourneyType.EDITOR;
  }

  const entries = Object.entries(JOURNEY_ROUTE_CONFIG).sort(
    ([a], [b]) => b.length - a.length,
  );

  for (const [pattern, journeyType] of entries) {
    if (matchPath({ path: pattern, end: false }, pathname)) {
      return journeyType;
    }
  }

  return null;
};

export function getScrollParent(
  node: HTMLElement | null,
): HTMLElement | Window {
  while (node && node !== document.body) {
    const style = getComputedStyle(node);
    if (
      /(auto|scroll)/.test(style.overflow + style.overflowY + style.overflowX)
    )
      return node;
    node = node.parentElement;
  }
  return window; // fallback
}
